'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getObservations = exports.isSharedLayoutCompatible = exports.getAvailableChartTypes = exports.getObservationsType = exports.getInformationsStateFromNewProps = exports.getFooterProps = exports.getHeaderProps = exports.getTimePeriodLabel = exports.getFullName = exports.getCellValue = exports.v8Transformer = exports.toSingularity = exports.getErrors = exports.toProperties = exports.toChartOptions = exports.toChartData = exports.onChangeProperties = exports.stateFromNewProps = exports.initialState = exports.chartTypes = exports.V8_SDMX_JSON = exports.DEFAULT_MAJOR_ATTRIBUTES = exports.DIMENSION_DISPLAY_PARTS = exports.DEFAULT_UPR_IDS = exports.dimensionValueDisplay = exports.isNonIdealState = exports.getTopologyAreasCollections = exports.sourceLabel = exports.header = exports.getUprs = exports.headerUprsLabel = exports.uprAttributesWithOneRelevantValue = exports.uprAttributes = exports.defaultSubtitle = exports.parseFocus = exports.focus = exports.source = exports.series = exports.choroSeries = exports.stackedSeries = exports.timelineSeries = exports.symbolSeries = exports.scatterSeries = exports.stackedDimension = exports.symbolDimension = exports.scatterDimension = exports.sampleSeries = exports.parseDisplay = exports.dimensionsWithValuesIndexedById = exports.splitDimensions = exports.getDimensionValues = exports.getRelevantsDatasetAttributes = exports.extractSdmxArtefacts = exports.extractDataName = exports.extractSdmxErrors = exports.freqM = exports.freqQ = exports.freqA = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _findIndex2 = require('lodash/findIndex');

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _includes2 = require('lodash/includes');

var _includes3 = _interopRequireDefault(_includes2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _filter2 = require('lodash/filter');

var _filter3 = _interopRequireDefault(_filter2);

var _reduce2 = require('lodash/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _flatten2 = require('lodash/flatten');

var _flatten3 = _interopRequireDefault(_flatten2);

var _isNil2 = require('lodash/isNil');

var _isNil3 = _interopRequireDefault(_isNil2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _keyBy2 = require('lodash/keyBy');

var _keyBy3 = _interopRequireDefault(_keyBy2);

var _size2 = require('lodash/size');

var _size3 = _interopRequireDefault(_size2);

var _compact2 = require('lodash/compact');

var _compact3 = _interopRequireDefault(_compact2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _reject2 = require('lodash/reject');

var _reject3 = _interopRequireDefault(_reject2);

var _partition4 = require('lodash/partition');

var _partition5 = _interopRequireDefault(_partition4);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _dimensionUtils = require('./dimension-utils');

Object.defineProperty(exports, 'dimensionValueDisplay', {
  enumerable: true,
  get: function get() {
    return _dimensionUtils.dimensionValueDisplay;
  }
});

var _constants = require('./constants');

Object.defineProperty(exports, 'DEFAULT_UPR_IDS', {
  enumerable: true,
  get: function get() {
    return _constants.DEFAULT_UPR_IDS;
  }
});
Object.defineProperty(exports, 'DIMENSION_DISPLAY_PARTS', {
  enumerable: true,
  get: function get() {
    return _constants.DIMENSION_DISPLAY_PARTS;
  }
});
Object.defineProperty(exports, 'DEFAULT_MAJOR_ATTRIBUTES', {
  enumerable: true,
  get: function get() {
    return _constants.DEFAULT_MAJOR_ATTRIBUTES;
  }
});
Object.defineProperty(exports, 'V8_SDMX_JSON', {
  enumerable: true,
  get: function get() {
    return _constants.V8_SDMX_JSON;
  }
});
Object.defineProperty(exports, 'chartTypes', {
  enumerable: true,
  get: function get() {
    return _constants.TYPES;
  }
});

var _properties = require('./properties');

Object.defineProperty(exports, 'initialState', {
  enumerable: true,
  get: function get() {
    return _properties.initialState;
  }
});
Object.defineProperty(exports, 'stateFromNewProps', {
  enumerable: true,
  get: function get() {
    return _properties.stateFromNewProps;
  }
});
Object.defineProperty(exports, 'onChangeProperties', {
  enumerable: true,
  get: function get() {
    return _properties.onChangeProperties;
  }
});
Object.defineProperty(exports, 'toChartData', {
  enumerable: true,
  get: function get() {
    return _properties.toChartData;
  }
});
Object.defineProperty(exports, 'toChartOptions', {
  enumerable: true,
  get: function get() {
    return _properties.toChartOptions;
  }
});
Object.defineProperty(exports, 'toProperties', {
  enumerable: true,
  get: function get() {
    return _properties.toProperties;
  }
});
Object.defineProperty(exports, 'getErrors', {
  enumerable: true,
  get: function get() {
    return _properties.getErrors;
  }
});
Object.defineProperty(exports, 'toSingularity', {
  enumerable: true,
  get: function get() {
    return _properties.toSingularity;
  }
});

var _v8Transformer = require('./v8-transformer');

Object.defineProperty(exports, 'v8Transformer', {
  enumerable: true,
  get: function get() {
    return _v8Transformer.dataTransformer;
  }
});

var _table = require('./table');

Object.defineProperty(exports, 'getCellValue', {
  enumerable: true,
  get: function get() {
    return _table.getCellValue;
  }
});

var _sdmxData = require('./sdmx-data');

Object.defineProperty(exports, 'getFullName', {
  enumerable: true,
  get: function get() {
    return _sdmxData.getFullName;
  }
});

var _date = require('./date');

Object.defineProperty(exports, 'getTimePeriodLabel', {
  enumerable: true,
  get: function get() {
    return _date.getTimePeriodLabel;
  }
});

var _getHeaderProps = require('./properties/getHeaderProps');

Object.defineProperty(exports, 'getHeaderProps', {
  enumerable: true,
  get: function get() {
    return _getHeaderProps.getHeaderProps;
  }
});
Object.defineProperty(exports, 'getFooterProps', {
  enumerable: true,
  get: function get() {
    return _getHeaderProps.getFooterProps;
  }
});

var _getInformationsStateFromNewProps = require('./properties/getInformationsStateFromNewProps');

Object.defineProperty(exports, 'getInformationsStateFromNewProps', {
  enumerable: true,
  get: function get() {
    return _getInformationsStateFromNewProps.getInformationsStateFromNewProps;
  }
});

var _getObservationsType = require('./properties/getObservationsType');

Object.defineProperty(exports, 'getObservationsType', {
  enumerable: true,
  get: function get() {
    return _getObservationsType.getObservationsType;
  }
});

var _getAvailableChartTypes = require('./properties/getAvailableChartTypes');

Object.defineProperty(exports, 'getAvailableChartTypes', {
  enumerable: true,
  get: function get() {
    return _getAvailableChartTypes.getAvailableChartTypes;
  }
});

var _layout = require('./layout');

Object.defineProperty(exports, 'isSharedLayoutCompatible', {
  enumerable: true,
  get: function get() {
    return _layout.isSharedLayoutCompatible;
  }
});

var _getObservations = require('./preparators/getObservations');

Object.defineProperty(exports, 'getObservations', {
  enumerable: true,
  get: function get() {
    return _getObservations.getObservations;
  }
});

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _lodash = require('lodash.compose');

var _lodash2 = _interopRequireDefault(_lodash);

var _memoizee = require('memoizee');

var _memoizee2 = _interopRequireDefault(_memoizee);

var _sampleSeries2 = require('./factories/sample-series');

var _sampleSeries3 = _interopRequireDefault(_sampleSeries2);

var _sampleFocus = require('./factories/sample-focus');

var _sampleFocus2 = _interopRequireDefault(_sampleFocus);

var _scatterSeries2 = require('./factories/scatter-series');

var _scatterSeries3 = _interopRequireDefault(_scatterSeries2);

var _scatterFocus = require('./factories/scatter-focus');

var _scatterFocus2 = _interopRequireDefault(_scatterFocus);

var _scatterDimension2 = require('./factories/scatter-dimension');

var _scatterDimension3 = _interopRequireDefault(_scatterDimension2);

var _symbolSeries2 = require('./factories/symbol-series');

var _symbolSeries3 = _interopRequireDefault(_symbolSeries2);

var _symbolDimension2 = require('./factories/symbol-dimension');

var _symbolDimension3 = _interopRequireDefault(_symbolDimension2);

var _timelineSeries2 = require('./factories/timeline-series');

var _timelineSeries3 = _interopRequireDefault(_timelineSeries2);

var _timelineFocus = require('./factories/timeline-focus');

var _timelineFocus2 = _interopRequireDefault(_timelineFocus);

var _stackedSeries2 = require('./factories/stacked-series');

var _stackedSeries3 = _interopRequireDefault(_stackedSeries2);

var _stackedDimension2 = require('./factories/stacked-dimension');

var _stackedDimension3 = _interopRequireDefault(_stackedDimension2);

var _choroSeries2 = require('./factories/choro-series');

var _choroSeries3 = _interopRequireDefault(_choroSeries2);

var _observationFormater = require('./observation-formater');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var freqA = exports.freqA = _constants.FREQ_A;
var freqQ = exports.freqQ = _constants.FREQ_Q;
var freqM = exports.freqM = _constants.FREQ_M;

// --------------------------------------------------------------------------------extractSdmxErrors
var _extractSdmxErrors = function _extractSdmxErrors(data) {
  return (0, _lodash2.default)(function (errors) {
    return (0, _map3.default)(errors, function (error) {
      return { label: error.code, description: error.message };
    });
  }, function (data) {
    return (0, _get3.default)(data, 'errors', []);
  });
};
var extractSdmxErrors = exports.extractSdmxErrors = (0, _memoizee2.default)(_extractSdmxErrors);

var extractDataName = exports.extractDataName = function extractDataName(data) {
  return R.pathOr(null, ['structure', 'name'], data);
};

// -----------------------------------------------------------------------------extractSdmxArtefacts
var _extractSdmxArtefacts = function _extractSdmxArtefacts(data) {
  var parseStructure = function parseStructure(data) {
    return (0, _get3.default)(data, 'structure', {});
  };
  var parseItem = function parseItem(item) {
    return parseComponents((0, _get3.default)(item, 'observation', []));
  };
  var parseDimensions = function parseDimensions(structure) {
    return parseItem((0, _get3.default)(structure, 'dimensions', {}));
  };
  var parseAttributes = function parseAttributes(structure) {
    return parseItem((0, _get3.default)(structure, 'attributes', {}));
  };
  var parseComponents = function parseComponents(components) {
    return (0, _map3.default)(components, parseComponent);
  };
  var parseComponent = function parseComponent(component, index) {
    var parsed = (0, _extends3.default)({}, (0, _pick3.default)(component, 'id', 'name', 'values', 'role', 'isHidden'), { index: index });
    if ((0, _isEmpty3.default)(parsed)) return parsed;
    if ((0, _isNil3.default)(parsed.role)) parsed.role = parsed.id;
    parsed.values = R.sortBy(R.prop('__index'))(parsed.values);
    return parsed;
  };
  var parseDatasetItem = function parseDatasetItem(item) {
    return parseComponents((0, _get3.default)(item, 'dataSet', []));
  };
  var parseDatasetAttributes = function parseDatasetAttributes(structure) {
    return parseDatasetItem((0, _get3.default)(structure, 'attributes', {}));
  };

  return {
    attributes: parseAttributes(parseStructure(data)),
    datasetAttributes: parseDatasetAttributes(parseStructure(data)),
    dimensions: parseDimensions(parseStructure(data)),
    id: (0, _get3.default)(data, 'header.id', null),
    name: extractDataName(data),
    observations: R.pipe(R.pathOr({}, ['dataSets', 0, 'observations']), R.mapObjIndexed(function (obs) {
      return R.over(R.lensIndex(0), function (val) {
        return R.isNil(val) ? null : Number(val);
      })(obs);
    }), R.reject(R.pipe(R.head, R.anyPass([R.isNil, isNaN]))))(data),
    source: (0, _get3.default)(data, 'header.links[0].href', null)
  };
};
var extractSdmxArtefacts = exports.extractSdmxArtefacts = (0, _memoizee2.default)(_extractSdmxArtefacts);

var _getRelevantsDatasetAttributes = function _getRelevantsDatasetAttributes(data) {
  var _extractSdmxArtefacts2 = extractSdmxArtefacts(data),
      datasetAttributes = _extractSdmxArtefacts2.datasetAttributes;

  return (0, _filter3.default)(datasetAttributes, function (attr) {
    return (0, _size3.default)(attr.values) === 1;
  });
};
var getRelevantsDatasetAttributes = exports.getRelevantsDatasetAttributes = (0, _memoizee2.default)(_getRelevantsDatasetAttributes);

// -------------------------------------------------------------------------------getDimensionValues
var getDimensionValues = exports.getDimensionValues = function getDimensionValues(dimension) {
  return (0, _get3.default)(dimension, 'values', []);
};

// ----------------------------------------------------------------------------------splitDimensions
var _splitDimensions = function _splitDimensions(data) {
  var _extractSdmxArtefacts3 = extractSdmxArtefacts(data),
      dimensions = _extractSdmxArtefacts3.dimensions;

  var _partition2 = (0, _partition5.default)((0, _reject3.default)(dimensions, (0, _lodash2.default)(_isEmpty3.default, getDimensionValues)), (0, _lodash2.default)(function (values) {
    return (0, _size3.default)(values) === 1;
  }, getDimensionValues)),
      _partition3 = (0, _slicedToArray3.default)(_partition2, 2),
      value = _partition3[0],
      values = _partition3[1];

  return { value: value, values: values };
};
var splitDimensions = exports.splitDimensions = (0, _memoizee2.default)(_splitDimensions);

// ------------------------------------------------------------------dimensionsWithValuesIndexedById
var _dimensionsWithValuesIndexedById = function _dimensionsWithValuesIndexedById(data) {
  return (0, _lodash2.default)(function (dimensionsWithValues) {
    return (0, _keyBy3.default)(dimensionsWithValues, 'id');
  }, function (split) {
    return split.values;
  }, splitDimensions)(data);
};
var dimensionsWithValuesIndexedById = exports.dimensionsWithValuesIndexedById = (0, _memoizee2.default)(_dimensionsWithValuesIndexedById);

// -------------------------------------------------------------------------------------parseDisplay
var _parseDisplay = function _parseDisplay(display) {
  return (0, _isNil3.default)(display) || !(0, _includes3.default)(['both', 'code'], display) ? 'label' : display;
};
var parseDisplay = exports.parseDisplay = (0, _memoizee2.default)(_parseDisplay);

// -------------------------------------------------------------------------------------sampleSeries
var _sampleSeries = function _sampleSeries(data, type, display, formaterIds) {
  return (0, _sampleSeries3.default)(type, extractSdmxArtefacts(data), dimensionsWithValuesIndexedById(data), parseDisplay(display), (0, _observationFormater.getObservationsFormaterAttributes)(data, formaterIds));
};
var sampleSeries = exports.sampleSeries = (0, _memoizee2.default)(_sampleSeries);

// ---------------------------------------------------------------------------------scatterDimension
var _scatterDimension = function _scatterDimension(data, ids) {
  var _splitDimensions2 = splitDimensions(data),
      values = _splitDimensions2.values;

  return (0, _scatterDimension3.default)(values, ids);
};
var scatterDimension = exports.scatterDimension = (0, _memoizee2.default)(_scatterDimension);

// ----------------------------------------------------------------------------------symbolDimension
var _symbolDimension = function _symbolDimension(data, ids) {
  var _splitDimensions3 = splitDimensions(data),
      values = _splitDimensions3.values;

  return (0, _symbolDimension3.default)(values, ids);
};
var symbolDimension = exports.symbolDimension = (0, _memoizee2.default)(_symbolDimension);

var _stackedDimension = function _stackedDimension(data, singularity) {
  return (0, _stackedDimension3.default)(splitDimensions(data), singularity);
};
var stackedDimension = exports.stackedDimension = (0, _memoizee2.default)(_stackedDimension);

// ------------------------------------------------------------------------------------scatterSeries
var _scatterSeries = function _scatterSeries(data, ids, display, formaterIds) {
  return (0, _scatterSeries3.default)(extractSdmxArtefacts(data), dimensionsWithValuesIndexedById(data), scatterDimension(data, ids), parseDisplay(display), (0, _observationFormater.getObservationsFormaterAttributes)(data, formaterIds));
};
var scatterSeries = exports.scatterSeries = (0, _memoizee2.default)(_scatterSeries);

// -------------------------------------------------------------------------------------symbolSeries
var _symbolSeries = function _symbolSeries(data, type, ids, display, formaterIds) {
  return (0, _symbolSeries3.default)(extractSdmxArtefacts(data), type, dimensionsWithValuesIndexedById(data), symbolDimension(data, ids), parseDisplay(display), (0, _observationFormater.getObservationsFormaterAttributes)(data, formaterIds));
};
var symbolSeries = exports.symbolSeries = (0, _memoizee2.default)(_symbolSeries);

// -----------------------------------------------------------------------------------timelineSeries
var _timelineSeries = function _timelineSeries(data, display, formaterIds) {
  return (0, _timelineSeries3.default)(extractSdmxArtefacts(data), dimensionsWithValuesIndexedById(data), parseDisplay(display), (0, _observationFormater.getObservationsFormaterAttributes)(data, formaterIds));
};
var timelineSeries = exports.timelineSeries = (0, _memoizee2.default)(_timelineSeries);

var _stackedSeries = function _stackedSeries(data, singularity, display, formaterIds, _ref) {
  var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
      stackKey = _ref2[0],
      categoryKey = _ref2[1];

  return (0, _stackedSeries3.default)(extractSdmxArtefacts(data), dimensionsWithValuesIndexedById(data), stackedDimension(data, singularity), parseDisplay(display), (0, _observationFormater.getObservationsFormaterAttributes)(data, formaterIds), [stackKey, categoryKey]);
};
var stackedSeries = exports.stackedSeries = (0, _memoizee2.default)(_stackedSeries);

// --------------------------------------------------------------------------------------choroSeries
var _choroSeries = function _choroSeries(data, map, display) {
  return (0, _choroSeries3.default)(extractSdmxArtefacts(data), dimensionsWithValuesIndexedById(data), map, parseDisplay(display));
};
var choroSeries = exports.choroSeries = (0, _memoizee2.default)(_choroSeries);

// -------------------------------------------------------------------------------------------series
var _series = function _series(data, type, focus, singularity, map, display, formaterIds) {
  switch (type) {
    case 'RowChart':case 'BarChart':
      return (0, _sampleFocus2.default)(sampleSeries(data, type, display, formaterIds), focus);
    case 'ScatterChart':
      return (0, _scatterFocus2.default)(scatterSeries(data, singularity, display, formaterIds), focus);
    case 'HorizontalSymbolChart':case 'VerticalSymbolChart':
      return (0, _sampleFocus2.default)(symbolSeries(data, type, singularity, display, formaterIds), focus);
    case 'TimelineChart':
      return (0, _timelineFocus2.default)(timelineSeries(data, display, formaterIds), focus);
    case 'StackedBarChart':
      return (0, _sampleFocus2.default)(stackedSeries(data, singularity, display, formaterIds, ['y', 'x']), focus);
    case 'StackedRowChart':
      return (0, _sampleFocus2.default)(stackedSeries(data, singularity, display, formaterIds, ['x', 'y']), focus);
    case 'ChoroplethChart':
      return choroSeries(data, map, display);
  }
};
var series = exports.series = (0, _memoizee2.default)(_series);

// -------------------------------------------------------------------------------------------source
var _source = function _source(data, config, meta) {
  var hasSource = (0, _get3.default)(meta, 'hasSource', true);
  if (!hasSource) return null;
  var source = (0, _get3.default)(config, 'source', null);
  if (source && !(0, _isEmpty3.default)(source)) return source;
  var artefacts = extractSdmxArtefacts(data);
  var uri = (0, _get3.default)(artefacts, 'source');
  if (!uri) return (0, _get3.default)(config, 'defaultSource', null);
  var match = uri.match(/(^http.*)\/SDMX-JSON\/data\/([^\/]+)\//);
  if ((0, _size3.default)(match) !== 3) return null;

  var _match = (0, _slicedToArray3.default)(match, 3),
      m = _match[0],
      domain = _match[1],
      dataset = _match[2];

  return domain + '/Index.aspx?DataSetCode=' + dataset; //tmp
};
var source = exports.source = (0, _memoizee2.default)(_source);

// --------------------------------------------------------------------------------------------focus
var _focus = function _focus(data, type, dimension, _display) {
  var display = parseDisplay(_display);
  switch (type) {
    case 'RowChart':case 'BarChart':
    case 'HorizontalSymbolChart':case 'VerticalSymbolChart':
    case 'StackedBarChart':case 'StackedRowChart':
      return (0, _lodash2.default)(function (datapoints) {
        return (0, _map3.default)(datapoints, function (dp) {
          return { label: dp.category, value: dp.key };
        });
      }, function (series) {
        return series[0].datapoints;
      }, series)(data, type, null, dimension, null, display);
    case 'TimelineChart':
      return (0, _lodash2.default)(function (series) {
        return (0, _map3.default)(series, function (serie) {
          return { label: serie.category, value: serie.key };
        });
      }, series)(data, type, null, dimension, null, display);
    case 'ScatterChart':
      var id = (0, _get3.default)(dimension, 'id');
      if ((0, _isNil3.default)(id)) return [];
      var dimensions = (0, _lodash2.default)(function (dimensions) {
        return (0, _omit3.default)(dimensions, id);
      }, dimensionsWithValuesIndexedById)(data);
      return (0, _flatten3.default)((0, _map3.default)(dimensions, function (dimension) {
        return (0, _map3.default)((0, _get3.default)(dimension, 'values'), function (value) {
          return {
            label: (0, _dimensionUtils.dimensionValueDisplay)(display)(dimension) + ' - ' + (0, _dimensionUtils.dimensionValueDisplay)(display)(value),
            options: { dimensionId: dimension.id, dimensionValueId: value.id },
            value: dimension.id + '-' + value.id
          };
        });
      }));
  }
};
var focus = exports.focus = (0, _memoizee2.default)(_focus);

var _parseFocus = function _parseFocus(data, type, dimension, display, _ref3) {
  var baseline = _ref3.baseline,
      highlight = _ref3.highlight;

  var options = focus(data, type, dimension, display);

  var parseSelection = function parseSelection(selection) {
    return (0, _compact3.default)((0, _map3.default)(selection, function (_ref4) {
      var value = _ref4.value;
      return (0, _find3.default)(options, function (option) {
        return (0, _isEqual3.default)(option.value, value);
      });
    }));
  };
  return { baseline: parseSelection(baseline), highlight: parseSelection(highlight) };
};
var parseFocus = exports.parseFocus = (0, _memoizee2.default)(_parseFocus);

var _defaultSubtitle = function _defaultSubtitle(data, display) {
  var REJECTED_SUBTITLE_IDS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.DEFAULT_REJECTED_SUBTITLE_IDS;

  var _splitDimensions4 = splitDimensions(data),
      value = _splitDimensions4.value;

  var values = (0, _reduce3.default)(R.reject(R.prop('isHidden'))(value), function (memo, d) {
    var dvId = (0, _get3.default)(d, 'values[0].id');
    if (!(0, _includes3.default)(REJECTED_SUBTITLE_IDS, dvId)) {
      memo.push((0, _dimensionUtils.dimensionValueDisplay)(display)(d) + ': ' + (0, _dimensionUtils.dimensionValueDisplay)(display)((0, _get3.default)(d, 'values[0]')));
    }
    return memo;
  }, []);
  return values;
};
var defaultSubtitle = exports.defaultSubtitle = (0, _memoizee2.default)(_defaultSubtitle);

var _uprAttributes = function _uprAttributes(attributes) {
  var UPR_IDS = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.DEFAULT_UPR_IDS;
  return (0, _reduce3.default)(UPR_IDS, function (memo, ids, uprKey) {
    var attr = (0, _find3.default)(attributes, function (attribute) {
      return (0, _includes3.default)(ids, (0, _get3.default)(attribute, 'id'));
    });
    if (attr) {
      memo[uprKey] = attr;
    }
    return memo;
  }, {});
};
var uprAttributes = exports.uprAttributes = (0, _memoizee2.default)(_uprAttributes);

var _uprAttributesWithOneRelevantValue = function _uprAttributesWithOneRelevantValue(uprAttributes) {
  var UPR_IDS = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.DEFAULT_UPR_IDS;
  var REJECTED_UPR_VALUES_IDS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.DEFAULT_REJECTED_UPR_VALUES_IDS;
  return (0, _reduce3.default)(uprAttributes, function (memo, attr, key) {
    if ((0, _size3.default)((0, _get3.default)(attr, 'values', [])) === 1 && !(0, _includes3.default)(REJECTED_UPR_VALUES_IDS[key], (0, _get3.default)(attr, 'values[0].id', ''))) memo[key] = attr;
    return memo;
  }, {});
};
var uprAttributesWithOneRelevantValue = exports.uprAttributesWithOneRelevantValue = (0, _memoizee2.default)(_uprAttributesWithOneRelevantValue);

var headerUprsLabel = exports.headerUprsLabel = function headerUprsLabel(display) {
  return function (uprAttributes) {
    return (0, _map3.default)(uprAttributes, function (attr) {
      return (0, _dimensionUtils.dimensionValueDisplay)(display)((0, _get3.default)(attr, 'values[0]'));
    }).join(', ');
  };
};

var getUprs = exports.getUprs = function getUprs(data, display) {
  return (0, _lodash2.default)(headerUprsLabel(parseDisplay(display)), uprAttributesWithOneRelevantValue, function (_ref5) {
    var attributes = _ref5.attributes;
    return uprAttributes(attributes);
  }, extractSdmxArtefacts)(data);
};

var _header = function _header(data, _title, _subtitle, _display) {
  var display = parseDisplay(_display);
  var title = (0, _isNil3.default)(_title) || (0, _isEmpty3.default)(_title) ? (0, _get3.default)(data, 'structure.name') : _title;
  var subtitle = (0, _isNil3.default)(_subtitle) || (0, _isEmpty3.default)(_subtitle) ? defaultSubtitle(data, display) : _subtitle;
  return {
    title: title,
    subtitle: (0, _isArray3.default)(subtitle) ? subtitle : [subtitle],
    uprs: (0, _lodash2.default)(headerUprsLabel(display), uprAttributesWithOneRelevantValue, function (_ref6) {
      var attributes = _ref6.attributes;
      return uprAttributes(attributes);
    }, extractSdmxArtefacts)(data)
  };
};
var header = exports.header = (0, _memoizee2.default)(_header);

var _sourceLabel = function _sourceLabel(data, label) {
  return (0, _isNil3.default)(label) || (0, _isEmpty3.default)(label) ? extractSdmxArtefacts(data).name : label;
};
var sourceLabel = exports.sourceLabel = (0, _memoizee2.default)(_sourceLabel);

var _getTopologyAreasCollections = function _getTopologyAreasCollections(topology) {
  return (0, _map3.default)(topology.objects, function (entry, key) {
    return key;
  });
};
var getTopologyAreasCollections = exports.getTopologyAreasCollections = (0, _memoizee2.default)(_getTopologyAreasCollections);

var _isNonIdealState = function _isNonIdealState(data, type, map) {
  var defaultSeries = series(data, type, null, null, map);
  if (type === 'ChoroplethChart') {
    return (0, _findIndex3.default)((0, _get3.default)(defaultSeries, 'objects.areas.geometries', []), function (geometry) {
      return (0, _get3.default)(geometry, 'properties.value', null);
    }) === -1;
  }
  return (0, _isEmpty3.default)((0, _get3.default)(defaultSeries, '[0].datapoints', []));
};
var isNonIdealState = exports.isNonIdealState = (0, _memoizee2.default)(_isNonIdealState);